import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const MetaAdsIcon = memo(({ className, style }: SVGProps) => {
  return (
    <svg className={className} style={style} viewBox="0 0 33 32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.972 7.76c2.569-1.619 5.15-1.678 7.745-.177 2.578 1.488 3.838 3.749 3.781 6.781a6.502 6.502 0 0 1-.868 3.124l-3.891 6.744a2.528 2.528 0 1 1-4.375-2.531l3.765-6.467a2.38 2.38 0 0 0-.886-3.226 2.374 2.374 0 0 0-3.227.849l-2.253 3.91c-.1.23-.212.454-.338.672l-3.922 6.794a2.532 2.532 0 0 1-4.476-2.364l.09-.17 2.968-5.144c.051-.147.117-.292.198-.432l.766-1.323a2.383 2.383 0 0 0-.9-2.74l-.16-.1a2.371 2.371 0 0 0-3.24.869l-6.53 11.4a2.525 2.525 0 0 1-4.633-.608 2.536 2.536 0 0 1 .253-1.924l6.705-11.631a6.492 6.492 0 0 1 2.273-2.32c2.592-1.562 5.176-1.599 7.753-.11a8.201 8.201 0 0 1 1.882 1.46c.43-.522.944-.972 1.52-1.336z"
        fillRule="evenodd"
      />
    </svg>
  )
})
